
define('text!app/board/templates/draftInfoRosterPickTemplate.html',[],function () { return '<tr>\r\n\t<td class="playerRankingsStatusRowTitle">{{ pos }}</td>\r\n\t<td class="playerRankingsStatusRowName">{{ name }}</td>\t\r\n</tr>';});
